import variables from '../common/variables';

const styles = {
  app: {
    fontFamily: 'Roboto',
    position: 'relative',
    width: '100%',
    height: '100%',
    outline: 'none',
    WebkitTapHighlightColor: 'rgba(0,0,0,0)',
  },
  container: {
    position: 'absolute',
    width: '100%',
    height: '100%',
  },
  slideWrapper: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    perspective: '3000px',
    transition: 'transform 0.25s ease-in-out',
  },
  slide: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backfaceVisibility: 'hidden',
    WebkitBackfaceVisibility: 'hidden', // usefull for 3D flip transition on safari
    overflow: 'hidden',
    willChange: 'transform, filter',
  },
  block: {
    display: 'block',
    position: 'absolute',
  },
  rectangle: {
    textIndent: '-99999px',
  },
  circle: {
    textIndent: '-99999px',
    borderRadius: '50%',
  },
  title: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    useSelect: 'none',
    paddingRight: 5,
    fontSize: '14px',
    marginRight: 6,
    maxWidth: '400px',
    minWidth: '50px',
  },
  status: {
    fontWeight: 500,
    color: 'var(--secondaryColor)',
  },
  text: {
    overflow: 'visible',
  },
  textInner: {
    position: 'absolute',
    left: '0',
    top: '0',
  },
  line: {
    whiteSpace: 'nowrap',
    display: 'inline-block',
    width: '100%',
  },
  image: {
    display: 'block',
    backgroundColor: 'transparent',
  },
  video: {
    display: 'block',
    backgroundColor: 'transparent',
  },
  emptyBlock: {
    position: 'absolute',
    left: '0',
    top: '0',
    right: '0',
    bottom: '0',
    backgroundColor: 'lightgrey',
  },
  rich: {
    display: 'block',
    backgroundColor: 'transparent',
    overflow: 'hidden',
  },
  richInner: {
    position: 'absolute',
  },
  transparentOverlay: {
    position: 'absolute',
    left: '0',
    top: '0',
  },
  controls: {
    width: '100%',
    position: 'absolute',
    display: 'flex',
    justifyContent: 'space-between',
    zIndex: '10',
    transitionDuration: '250ms',
    transitionProperty: 'opacity, visibility, margin',
    transitionTimingFunction: 'ease-in-out',
    backgroundColor: 'var(--panelColor)',
    MozUserSelect: 'none',
    WebkitUserSelect: 'none',
    MsUserSelect: 'none',
    userSelect: 'none',
    height: '38px',
  },
  controlsCentered: {
    width: 'auto',
    top: '11px',
    transform: 'translate(-50% 0)',
    position: 'absolute',
    display: 'flex',
    justifyContent: 'space-between',
    zIndex: '10',
    transitionDuration: '250ms',
    transitionProperty: 'opacity, visibility, margin',
    transitionTimingFunction: 'ease-in-out',
    backgroundColor: 'var(--panelColor)',
    borderRadius: '10px',
    MozUserSelect: 'none',
    WebkitUserSelect: 'none',
    MsUserSelect: 'none',
    userSelect: 'none',
    height: '42px',
    border: '1px solid rgba(255,255,255,0.2)',
  },

  arrow: {
    position: 'absolute',
    boxSizing: 'content-box',
    zIndex: '10',
    color: 'white',
    fontSize: '40px',
    transform: 'translateZ(0px)',
  },
  arrowControl: {
    position: 'relative',
    backgroundColor: variables.colors.black,
  },
  arrowIcon: {
    display: 'block',
    marginRight: '4px',
    lineHeight: '40px',
  },
  controlsBase: {
    display: 'block',
    padding: '4px 0 4px 4px',
  },

  controlsList: {
    listStyle: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    position: 'relative',
  },
  logoImage: {
    display: 'block',
    width: '17px',
    height: '26px',
  },
  buttonWrapper: {
    paddingRight: '4px',
    fontWeight: 500,
  },
  primaryButton: {
    display: 'flex',
    minWidth: '26px',
    maxWidth: '100%',
    height: '30px',
    color: variables.colors.white,
    backgroundColor: variables.colors.blue,
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'transparent',
    fontFamily: 'Roboto, sans-serif',
    outline: 'none',
    cursor: 'pointer',
    position: 'relative',
    transition: 'all 0.2s ease-out 0s',
    borderRadius: '5px',
    justifyContent: 'center',
    flex: '1 1 0%',
    textAlign: 'center',
    aligntems: 'center',
    lineHeight: '26px',
    fontSize: '14px',
    fontWeight: '700',
    paddingRight: '10px',
    paddingLeft: '10px',
  },
  ghostButton: {
    display: 'flex',
    minWidth: '36px',
    maxWidth: '100%',
    height: '30px',
    color: variables.colors.blue,
    backgroundColor: 'transparent',
    border: `1px solid ${variables.colors.blue}`,
    fontFamily: 'Roboto, sans-serif',
    outline: 'none',
    cursor: 'pointer',
    position: 'relative',
    transition: 'all 0.2s ease-out 0s',
    borderRadius: '5px',
    justifyContent: 'center',
    flex: '1 1 0%',
    marginRight: '18px',
    textAlign: 'center',
    alignItems: 'center',
    lineHeight: '26px',
    fontSize: '14px',
    fontWeight: '700',
  },
  button: {
    display: 'flex',
    color: variables.colors.white,
    border: '0',
    outline: 'none',
    cursor: 'pointer',
    transition: 'all .2s ease-in-out',
    lineHeight: '27px',
    fontSize: '28px',
    height: 32,
    minwidth: 32,
    borderRadius: '6px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonLabel: {
    color: variables.colors.white,
    fontSize: '14px',
    fontWeight: 500,
    display: 'flex',
    marginRight: 6,
    alignItems: 'center',
  },
  buttonIcon: {
    display: 'block',
  },

  slideCounter: {
    position: 'absolute',
    right: '0',
    top: '0',
    transitionDuration: '250ms',
    transitionProperty: 'opacity, transform',
    transitionTimingFunction: 'ease-in-out',
    display: 'flex',
    alignItems: 'center',
  },
  slideCounterInner: {
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 10px',
    fontSize: '14px',
    marginRight: '4px',
  },
  slideCounterCurrentSlide: {
    color: variables.colors.white,
  },
  slideCounterTotalSlides: {
    color: variables.colors.lightGrey,
  },
  slideCounterSeparator: {
    color: variables.colors.lightGrey,
  },
  progress: {
    position: 'absolute',
    left: '0',
    bottom: '0',
    width: '100%',
    zIndex: '10',
    background: variables.colors.darkBlue,
    transition: 'all .2s ease-in-out',
  },
  progressSlide: {
    height: '100%',
    background: 'rgba(255, 255, 255, 0.5)',
    opacity: '0',
    cursor: 'pointer',
    transition: 'all .2s ease-in-out',
    textAlign: 'center',
    overflow: 'hidden',
  },
  progressSlideThumbnail: {
    width: '162px',
    height: '92px',
    objectFit: 'contain',
    background: variables.colors.dashboardLightGrey,
    boxShadow: '0px 10px 10px rgba(0, 0, 0, 0.25)',
    borderRadius: '4px',
    border: `1px solid ${variables.colors.highlightBlue}`,
    display: 'block',
  },
  progressSlideThumbnailPlaceholder: {
    width: '162px',
    height: '92px',
  },
  progressSlideNumber: {
    position: 'relative',
    top: '-15px',
    height: '30px',
    lineHeight: '30px',
    minWidth: '30px',
    textAlign: 'center',
    padding: '0 10px',
    background: '#333',
    color: variables.colors.white,
    borderRadius: '4px',
    fontSize: '14px',
    display: 'inline-block',
    boxShadow: '0px 10px 10px rgba(0, 0, 0, 0.25)',
  },
  fullScreenOverlay: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: '0',
    bottom: '0',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(0,0,0,0.6)',
    WebkitBackdropFilter: 'blur(5px)',
    color: variables.colors.white,
  },
  fullScreenOverlayTitle: {
    fontSize: '24px',
    fontWeight: 'bold',
  },
  mediaVideo: {
    display: 'block',
    width: '100%',
    height: '100%',
    transform: 'scaleX(-1)',
    borderRadius: '50%',
  },
  mediaVideoPoster: {
    position: 'absolute',
    display: 'block',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    transform: 'scaleX(-1)',
  },
  counter: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    width: '100px',
    height: '100px',
    color: variables.colors.white,
    fontSize: '80px',
    fontWeight: '500',
    lineHeight: '100px',
    textAlign: 'center',
    marginLeft: '-50px',
    marginTop: '-50px',
    cursor: 'default',
  },
  iframeReplacement: {
    border: `1px solid ${variables.colors.white}`,
    backgroundColor: 'rgba(0,0,0,0.1)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  iframeReplacementFavicon: {
    width: '100px',
    height: '100px',
  },
  slidesExternalButtonContainer: {
    position: 'absolute',
    left: '7px',
    bottom: '9px',
    zIndex: '11',
    width: '111px',
    transition: 'all .2s ease-in-out',
  },
  slidesExternalButton: {
    display: 'block',
    minWidth: '36px',
    maxWidth: '100%',
    height: '30px',
    color: variables.colors.white,
    backgroundColor: variables.colors.darkerGrey,
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'transparent',
    fontFamily: 'Roboto, sans-serif',
    fontSize: '14px',
    fontWeight: 'bold',
    outline: 'none',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    position: 'relative',
    transition: 'all .2s ease-out',
    borderRadius: '5px',
  },
  slidesExternalButtonHover: {
    backgroundColor: variables.colors.blue,
  },
  slidesContainer: {
    position: 'fixed',
    left: '0',
    top: '0',
    bottom: '0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '145px',
    height: '100%',
    zIndex: '10',
    background:
      'linear-gradient(90deg, rgba(16,16,17,0.10) 0%, rgba(16,16,17,0.0) 100%)',
    transition: 'transform .25s ease-in-out',
    transitionDelay: '0.050s',
  },
  slidesList: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '145px',
    overflow: 'auto',
  },
  slidesListItem: {
    width: '109px',
    height: '55px',
    borderRadius: '5px',
    overflow: 'hidden',
    margin: '8px 0',
  },
  slidesListThumbnails: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
};

export default styles;
